module.exports = __webpack_public_path__ + "img/user2.b7a51c89.png";